// src/pages/markets/board/board/ScoredEventCard.tsx

import { memo } from 'react';
import { EventCard, type EventCardProps } from '../card/EventCard';
import { useEventScores } from '../api/useEventScores';

export interface ScoredEventCardProps extends Omit<EventCardProps, 'scores' | 'index'> {
    scoreGroups: readonly string[];
}

function ScoredEventCardInner({ scoreGroups, ...rest }: ScoredEventCardProps) {
    const { scores, index } = useEventScores(rest.event.event_id, scoreGroups);
    // Forwarded as well as consumed: the card's group toggle leads with the
    // column's score groups, which it can no longer name for itself.
    return <EventCard {...rest} scoreGroups={scoreGroups} scores={scores} index={index} />;
}

export const ScoredEventCard = memo(ScoredEventCardInner);